<template>
  <div>
    <div><el-input v-model="tip" :placeholder="placeholder"></el-input></div>
    <div class="imgs">
      <file-upload
        upload-type="button"
        bucket="yxmgt-public"
        v-model="imgs"
        :multiple="true"
        file-path="/common/recPoint"
        :btnText="btnText"
      />
    </div>
  </div>
</template>
<script>
export default {
  components: {},

  props: {
    value: Object,
    btnText: {
      type: String,
      default: "点击上传引导图片"
    },
    placeholder: {
      type: String,
      default: "引导提示文字"
    }
  },

  watch: {
    value: {
      handler(val) {
        if (val) {
          this.imgs = val.imgList;
          this.tip = val.tip;
        } else {
          this.imgs = [];
          this.tip = "";
        }
      },
      immediate: true
    },

    tip(val) {
      this.$emit("input", {
        imgList: this.imgs,
        tip: val
      });
    },

    imgs(val) {
      this.$emit("input", {
        imgList: val,
        tip: this.tip
      });
    }
  },

  created() {},

  mounted() {},

  computed: {},

  data() {
    return {
      imgs: [],
      tip: ""
    };
  },

  methods: {}
};
</script>
<style scoped lang="less">
.imgs {
  margin-top: 10px;
}
</style>
